import type { MenuItem } from '../stores/modules/menu/types';
import { equalToRoute } from './url';
import IconMenu from '../components/Icon/IconMenu.vue';

/**
 * 获取默认激活的菜单项
 * @param list 菜单列表
 * @param path 当前路径
 * @param setActiveSideMenu 用户自定义的侧边栏菜单激活处理函数，优先于默认匹配逻辑执行
 * @returns 匹配的菜单项或 undefined
 */
export const getDefaultActive = (
  list: MenuItem[],
  path: string,
  setActiveSideMenu?: ((path: string, menus?: MenuItem[]) => MenuItem | null) | null,
): MenuItem | undefined => {
  if (!list.length) {
    return;
  }

  // 如果用户提供了自定义处理函数，优先使用用户的逻辑
  if (typeof setActiveSideMenu === 'function') {
    const customResult = setActiveSideMenu(path, list);
    if (customResult) {
      return customResult;
    }
  }

  // 如果用户没有自定义函数或用户函数返回 null，则使用默认匹配逻辑
  for (const val of list) {
    if (equalToRoute(path, undefined, val.path)) {
      return val;
    }
    const target = getDefaultActive(val.children || [], path, setActiveSideMenu);
    if (target) {
      return target;
    }
  }

  return undefined;
};

// 绑定 el-menu 时，用了 v-bind，无差别的进行绑定
// 开发模式下 vue 会报警告，因此进行忽略
export const filterMenuProps = (data: MenuItem, withDefaultIcon?: boolean) => {
  return {
    path: data.path,
    title: data.title,
    id: data.id,
    icon: data.icon || (withDefaultIcon ? IconMenu : undefined),
    children: data.children,
    order: data.order,
    isLink: data.isLink,
    permission: data.permission,
    parent: data.parent,
    hideInMenu: data.hideInMenu,
    tagComponent: data.tagComponent,
  };
};
